import { useState } from 'react';
import type { ReactNode } from 'react';
import type { ObjectFitValue } from './styled';
import {
  Container,
  CopyContainer,
  CoverContainer,
  CoverImage,
  Description,
  Title,
} from './styled';
import Observer from '@researchgate/react-intersection-observer';

interface Props {
  name?: ReactNode;
  description?: ReactNode;
  coverFit?: ObjectFitValue;
  snowflakeScore?: number[];
  currencyISO?: string;
  coverImage?: string;
  coverImageSet?: string;
}

const Tile = ({
  name,
  description,
  coverFit,
  coverImage,
  coverImageSet,
}: Props) => {
  const [showCover, setShowCover] = useState(
    RUNTIME_ENV === 'server' ? true : false
  );
  function handleObserverChange(args) {
    if (args.isIntersecting && !showCover) setShowCover(true);
  }
  return (
    <Observer onChange={handleObserverChange}>
      <Container>
        <CoverContainer padded={coverFit === 'contain'}>
          {showCover && (
            <CoverImage
              objectFit={coverFit}
              src={coverImage}
              srcSet={coverImageSet}
              alt={`${name} cover`}
            />
          )}
        </CoverContainer>
        <CopyContainer>
          <Title>{name}</Title>
          <Description>{description}</Description>
        </CopyContainer>
      </Container>
    </Observer>
  );
};

Tile.defaultProps = {
  name: '',
  coverFit: 'cover',
  description: '',
  snowflakeScore: [1, 1, 1, 1, 1],
};

export default Tile;
